import P5 from 'p5';
import UIElement from './uiElement';
import { mouseInArea } from '../helpers';
import UIOverlay, { OverlayOwner } from './uiOverlay';

class DropDownList implements UIElement, OverlayOwner {
    x: number = 0;
    y: number = 0;
    w: number = 80;
    h: number = 20;

    toolTip: string = 'Select an option';
    selectedOption: string = '';
    options: string[] = [];
    activated: boolean = false;
    action: Function|null = null;

    constructor(w: number, options: string[], toolTip: string) {
        this.w = w;
        this.toolTip = toolTip;
        this.options = options;
        if(options.length > 0){
            this.selectedOption = options[0];
        }else{
            this.selectedOption = 'No options';
        }
    }

    updateLayout(): void {

    }

    //true when the expanded list should open upwards - i.e. when its
    //bottom would end up outside of the screen if it opened downwards
    opensUpwards(): boolean {
        return this.y + this.h + this.options.length * this.h > buffer.height/2;
    }

    //y position of option i in the expanded list, respecting the direction
    //the list opens in (options keep the same top-to-bottom order)
    getOptionY(i: number): number {
        if(this.opensUpwards()){
            return this.y - (this.options.length - i) * this.h;
        }
        return this.y + this.h + i * this.h;
    }

    //expanding claims the global overlay layer, so the list gets input
    //priority and is drawn above every other UI element
    setActivated(value: boolean){
        this.activated = value;
        if(value){
            UIOverlay.claim(this);
        }else{
            UIOverlay.release(this);
        }
    }

    render() {
        
        buffer.noStroke();
        buffer.fill(180);
        buffer.rect(this.x, this.y, this.w, this.h);

        if(mouseInArea(this.x+this.w-20, this.y, 20, this.h)){
            buffer.fill(150);
        }else{
            buffer.fill(100);
        }
        buffer.rect(this.x+this.w-20, this.y, 20, this.h);


        buffer.fill(0);
        buffer.textAlign(buffer.LEFT, buffer.CENTER);
        buffer.textSize(10);
        buffer.noStroke();
        buffer.text(this.selectedOption, this.x + 10, this.y + this.h/2);

        buffer.textAlign(buffer.CENTER, buffer.CENTER);
        buffer.text(this.opensUpwards() ? "^" : "V", this.x + this.w - 10, this.y + this.h/2);

        
    }

    // ------ overlay layer (the expanded list) ------

    renderOverlay(){
        buffer.noStroke();
        for(let i = 0; i < this.options.length; i++){
            let y = this.getOptionY(i);
            if(mouseInArea(this.x, y, this.w, this.h)){
                buffer.fill(180);
            }else{
                buffer.fill(150);
            }
            buffer.rect(this.x, y, this.w, this.h);
            if(this.selectedOption == this.options[i]){
                buffer.fill(0);
            }else{
                buffer.fill(80);
            }
            buffer.textSize(10);
            buffer.textAlign(buffer.LEFT, buffer.CENTER);
            buffer.text(this.options[i], this.x + 10, y + this.h/2);
        }
    }

    overlayContainsMouse(): boolean {
        //the control box itself
        if(mouseInArea(this.x, this.y, this.w, this.h)){
            return true;
        }
        //the expanded list
        let listTop = this.opensUpwards() ? this.y - this.options.length * this.h : this.y + this.h;
        return mouseInArea(this.x, listTop, this.w, this.options.length * this.h);
    }

    overlayMousePressed(): boolean {
        //click on the control itself - collapse (toggle behaviour)
        if(mouseInArea(this.x, this.y, this.w, this.h)){
            this.setActivated(false);
            return true;
        }

        //click on one of the options
        for(let i = 0; i < this.options.length; i++){
            if(mouseInArea(this.x, this.getOptionY(i), this.w, this.h)){
                this.selectedOption = this.options[i];
                console.log(`Option "${this.selectedOption}" selected`);
                this.setActivated(false);
                if(this.action){
                    this.action();
                }
                return true;
            }
        }

        //click outside - close the list and swallow the click, so whatever
        //happens to be underneath the list doesn't get triggered by accident
        this.setActivated(false);
        return true;
    }

    // ------ regular (collapsed) element behaviour ------

    renderTooltip(){
        if(this.activated){
            //the expanded list is drawn by the overlay layer on top of
            //everything - no hover tooltip while it is open
            return false;
        }

        if(mouseInArea(this.x, this.y, this.w, this.h)){
            let posX = p5js.int((p5js.mouseX/pixelSize) - (buffer.width/2)) + 5;
            let posY = p5js.int((p5js.mouseY/pixelSize) - (buffer.height/2)) + 5;
            buffer.stroke(255);
            buffer.strokeWeight(1);
            buffer.fill(0, 200);
            buffer.textSize(10);
            let w = buffer.textWidth(this.toolTip) + 10;
            buffer.rect(posX, posY, w, 20);
            buffer.noStroke();
            buffer.fill(255);
            buffer.textAlign(buffer.LEFT, buffer.CENTER);
            buffer.text(this.toolTip, posX+5, posY+10);
            return true;
        }
        return false;
    }

    mousePressed() : boolean {
        //while expanded, all clicks are handled by the overlay layer
        //(overlayMousePressed) before the regular UI tree is reached
        if(this.activated){
            return false;
        }

        if(mouseInArea(this.x, this.y, this.w, this.h)){
            console.log(`Drop down menu "${this.toolTip}" expanded`);
            this.setActivated(true);
            return true;
        }

        return false;
    }

    mouseReleased(): boolean {
        return false;
    }

    keyPressed(): boolean {
        return false;
    }

    keyReleased(): boolean {
        return false;
    }

    scroll(event: WheelEvent): boolean {
        return false;
    }

    pressed() : boolean {
        return false;
    }
}

export default DropDownList;